export default {
    isMSmartLife() {
        return !(/smartiolife/i.test(location.href) || /tsmart/i.test(location.href));
    },

    masBaseURL() {
        const base = {
            MSmartHome: {
                sit: 'https://mp-us-sit.appsmb.com/mas/v5/app/proxy?alias=',
                prod: 'https://mp-prod.appsmb.com/mas/v5/app/proxy?alias='
            },
            TSmartLife: {
                sit: 'https://mp-jp-sit.appsmb.com/mas/v5/app/proxy?alias=',
                prod: 'https://mp-jp-prod.appsmb.com/mas/v5/app/proxy?alias='
            }
        };
        const env = window.location.href.match(/sit|:80\d\d/) ? 'sit' : 'prod';

        return this.isMSmartLife() ? base.MSmartHome[env] : base.TSmartLife[env];
    },
    getQueryString (key) {
        // key存在先通过search取值如果取不到就通过hash来取
        let after = window.location.search.substr(1) || window.location.hash.split('?')[1];
        if (after) {
            if (!after.includes(key)) { // 微信分享带参数的链接，做特殊处理
                after = window.location.hash.split('?')[1];
                if (!after) { // 无自带参数
                    return null;
                }
            }
            const reg = new RegExp('(^|&)' + key + '=([^&]*)(&|$)');
            const r = after.match(reg);
            if (r != null) {
                return decodeURIComponent(r[2]);
            } else {
                return null;
            }
        } else {
            return null;
        }
    },

    /**
   * 标准语言码转换
   * @param {String} lang 非标语言码
   * @returns 标准语言码
   */
    handleLangCode(lang) {
            lang = lang.toLowerCase();
    
            if (lang.startsWith('en')) {
                return 'en_US';
            }
            if (lang.startsWith('zh')) {
                if (lang.match(/hk|hant/)) {
                    return 'zh_HK';
                }
                if (lang.match(/tw/)) {
                    return 'zh_TW';
                }
                return 'zh_CN';
            }
            return lang.substring(0, 2);
    },
}